// Port of yAxisTitle + yAxisLimits (products/chart.coffee:76-92, sections/chart.coffee:76-91).

import { round } from '@aytm/app/stats/lib/util/helpers'

export const getYAxisTitle = ({ viewMode, chartMode, options, percentCapableViews }) => {
  const base = options.find(o => o.value === viewMode)?.text || viewMode
  if (!percentCapableViews.includes(viewMode)) return base
  return base + (['respondents', 'brespondents'].includes(chartMode) ? ' (respondents)' : ' (percents)')
}

export const getYAxisLimits = ({ viewMode, items, hcAnswers, skipViewModes }) => {
  if (skipViewModes.includes(viewMode)) return null

  let min = 0
  let max = 0
  for (const item of items || []) {
    // hcAnswers amounts are already formatted strings — parseFloat matches coffee
    const raw = parseFloat(hcAnswers[`a${item.position}`]?.amount || 0)
    const amount = Number.isFinite(raw) ? raw : 0
    min = Math.min(min, amount)
    max = Math.max(max, amount)
  }

  min = min < 0 ? -Math.ceil(Math.abs(min)) : 0
  if (max <= 0 && min >= 0) max = 100
  else if (max <= 0) max = Math.ceil(Math.abs(min))
  else max = Math.ceil(max)

  return min === max ? null : [round(min, 2), round(max, 2)]
}
